import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ISbStoryData } from '@storyblok/js';
import { DynamicModule } from 'ng-dynamic-component';
import { Observable, tap } from 'rxjs';

import { PageComponent } from '@valk-nx/storyblok/components/page/src/lib/page.component';
import { MeetingRoomDetailComponent } from '@valk-nx/storyblok/pages/meeting-room-detail/src/lib/meeting-room-detail.component';
import { MeetingRoomOverviewComponent } from '@valk-nx/storyblok/pages/meeting-room-overview/src/lib/meeting-room-overview.component';
import { PackageDetailComponent } from '@valk-nx/storyblok/pages/package-detail/src/lib/package-detail.component';
import { PackageOverviewComponent } from '@valk-nx/storyblok/pages/package-overview/src/lib/package-overview.component';
import { RoomDetailComponent } from '@valk-nx/storyblok/pages/room-detail/src/lib/room-detail.component';
import { RoomOverviewComponent } from '@valk-nx/storyblok/pages/room-overview/src/lib/room-overview.component';
import { StoryblokService } from '@valk-nx/storyblok-services/src/lib/services/storyblok.service';
import { PageSettingsStore } from '@valk-nx/storyblok-store/src/lib/store/page-settings/page-settings.store';

const Components = {
	block: PageComponent,
	staticPage: PageComponent,
	packageDetail: PackageDetailComponent,
	packageOverview: PackageOverviewComponent,
	page: PageComponent,
	menulessPage: PageComponent,
	meetingRoomOverview: MeetingRoomOverviewComponent,
	meetingRoomDetail: MeetingRoomDetailComponent,
	roomDetail: RoomDetailComponent,
	roomOverview: RoomOverviewComponent,
};
@Component({
	selector: 'sb-root',
	templateUrl: './root.component.html',
	imports: [CommonModule, DynamicModule],
})
export class SbRootComponent {
	readonly pageSettingsStore = inject(PageSettingsStore);
	readonly story$: Observable<ISbStoryData>;
	components = Components;

	constructor(private readonly sbService: StoryblokService) {
		this.story$ = this.sbService.story$.pipe(
			tap({
				next: (story) => {
					const hideMenu = story.content.component === 'menulessPage';
					const hideFooter =
						story.content.component === 'menulessPage';
					this.pageSettingsStore.updateState({
						hideMenu,
						hideFooter,
					});
				},
			}),
		);
	}
}
